export default {
      id: "login-ah-usage",
      viewBox: "0 0 22 22",
      url: __webpack_public_path__ + "sprite-46b249.svg#login-ah-usage",
      toString: function () {
        return this.url;
      }
    }